import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {list, migrationData} from "../../../lib/api/migration";
import {toast} from "react-toastify";

export const Starter = () => {
    const [migration, setMigration] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMigration, setIsMigration] = useState(false);

    const handleMigration = async () => {
        setIsMigration(true);
        try {
            const _row = await migrationData();
            if(_row.status) {
                toast.success(_row.message);
                await getMigration();
            }
            else toast.error(_row.message);

        } catch (error) {
            console.error("Failed to delete item", error);
            toast.error(
                <span>
                    <p>Došlo je do greške.</p>
                    <p>{err.body?.message || err.message}</p>
                </span>
            );
        } finally {
            setIsMigration(false);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // mjeseci idu od 0
        const yyyy = date.getFullYear();

        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${dd}.${mm}.${yyyy} ${hh}:${min}:${ss}`;
    }


    const getMigration = () => {
        setIsLoading(true);
        list()
            .then((res) => setMigration(res))
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getMigration();
    }, []);

    return (
        <Card className={classNames('h-100')}>
            <Card.Header>
                <Row className="align-items-center justify-content-between">
                    <Col lg={6} className="ps-lg-4  text-center text-lg-start">
                        <Button
                            variant="falcon-primary"
                            onClick={() => handleMigration()}
                            disabled={isMigration}
                        >
                            {isMigration ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                                ):''}
                            <span className={"m-sm-1"}> Zapocni migraciju</span>
                        </Button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="bg-body-tertiary">
                {isLoading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    <>
                    <Row className="mb-3">
                        <Table responsive>
                            <thead>
                            <tr>
                                <th scope="col">Vrsta</th>
                                <th scope="col">Naziv</th>
                                <th scope="col">Vrijeme</th>
                            </tr>
                            </thead>
                            <tbody>
                            {migration.map((item, i) => (
                                <tr key={i}>
                                    <td className="text-nowrap">
                                        <div className="d-flex align-items-center">
                                            <div className="ms-2">{i+1}</div>
                                        </div>
                                    </td>
                                    <td className="text-nowrap">
                                        <div className="d-flex align-items-center">
                                            <div className="ms-2">{item.name}</div>
                                        </div>
                                    </td>
                                    <td className="text-nowrap">
                                        <div className="d-flex align-items-center">
                                            <div className="ms-2">{formatDateTime(item.date_change)}</div>
                                        </div>
                                    </td>

                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Row>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default Starter;
